import { DocumentTemplateType } from '@/Enums/DocumentTemplateType';
import { DocumentTemplateModel } from '@/Models';
import { Nullable } from '@/Types';
import { NumberGenerationType } from '@/Enums';
import { AutomaticallyGeneratedDocumentType } from '@/Enums/AutomaticallyGeneratedDocumentType';

const mappingDocumentTemplateModel = (
  guid: string,
  name: string,
  type: DocumentTemplateType,
): DocumentTemplateModel => {
  return {
    id: 0,
    guid: guid,
    name: name,
    type: type,
    documentTemplateSettings: {
      isOnlineArchive: false,
      fileName: '',
      separatingSign: '',
      directoryPath: '',
      isSaveWhenSending: false,
      isSaveWhenPrinting: false,
      documentTemplateFilePartNames: [],
      isForSale: false,
      isForPurchases: false,
      isForCustomers: false,
      isForWarehouse: false,
      countCopy: 1,
      isSortWhenPrinting: false,
      guid: '',
    },
    canRestore: false,
  };
};

const convertDocumentTypeToNumberGenerationType = (
  docType?: AutomaticallyGeneratedDocumentType | string,
): Nullable<NumberGenerationType> => {
  switch (docType) {
    case AutomaticallyGeneratedDocumentType.PL:
      return NumberGenerationType.PackList;

    case AutomaticallyGeneratedDocumentType.SORD:
      return NumberGenerationType.SaleOrder;

    case AutomaticallyGeneratedDocumentType.PORD:
      return NumberGenerationType.PurchaseOrder;

    case AutomaticallyGeneratedDocumentType.INV:
      return NumberGenerationType.Invoice;

    case AutomaticallyGeneratedDocumentType.CINV:
      return NumberGenerationType.CancelInvoice;

    default:
      return null;
  }
};

export const documentTemplateMapping = {
  mappingDocumentTemplateModel,
  convertDocumentTypeToNumberGenerationType,
};
